import permissions from './permission-list'

export default [
  {
    path: '/notification',
    name: 'notifications',
    component: () => import('@/views/notification/index.vue'),
    meta: {
      pageTitle: 'Notification',
      resource: permissions.notification,
      action: 'manage',
      breadcrumb: [
        {
          text: 'Notification',
          active: true,
        },
      ],
    },
  },
]
